import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoardAncestorPath } from "~/components/BoardAncestorPath";
export const DiscussionsMenuItem = (param)=>{
    let { adornmentRight, ancestors, thumbnail, title } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "my-1.5 flex w-full items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mr-3 size-10 overflow-hidden rounded",
                children: thumbnail
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex h-full flex-1 flex-col items-start justify-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-full truncate text-left text-14 font-normal text-inherit",
                        style: {
                            marginBottom: ancestors && !!ancestors.length ? 2 : 0
                        },
                        children: title
                    }),
                    !!ancestors && !!ancestors.length && /*#__PURE__*/ _jsx(BoardAncestorPath, {
                        ancestors: ancestors
                    })
                ]
            }),
            adornmentRight
        ]
    });
};
